<div [style.display]="isLoading ? 'block' : 'none'">
  <div class="loader-wrapper">
    <div class="d-flex justify-content-center">
      <div class="dots"></div>
    </div>
  </div>
</div>
